var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57145 1.42857V17.1429H16.4286V1.42857H3.57145ZM2.85717 0H17.1429C17.3323 0 17.514 0.0752549 17.648 0.209209C17.7819 0.343164 17.8572 0.524845 17.8572 0.714286V17.8571C17.8572 18.0466 17.7819 18.2283 17.648 18.3622C17.514 18.4962 17.3323 18.5714 17.1429 18.5714H2.85717C2.66773 18.5714 2.48605 18.4962 2.35209 18.3622C2.21814 18.2283 2.14288 18.0466 2.14288 17.8571V0.714286C2.14288 0.524845 2.21814 0.343164 2.35209 0.209209C2.48605 0.0752549 2.66773 0 2.85717 0Z",
    fill: "#727D9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1429H20V18.5715H0V17.1429ZM5.71429 2.85718H8.57143V5.00003H5.71429V2.85718Z",
    fill: "#727D9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14293 17.1429H12.8572V15.7143C12.8572 14.9566 12.5562 14.2298 12.0204 13.694C11.4846 13.1582 10.7578 12.8572 10.0001 12.8572C9.24231 12.8572 8.51558 13.1582 7.97976 13.694C7.44395 14.2298 7.14293 14.9566 7.14293 15.7143V17.1429ZM10.0001 11.4286C11.1367 11.4286 12.2268 11.8801 13.0305 12.6839C13.8343 13.4876 14.2858 14.5777 14.2858 15.7143V18.5715H5.71436V15.7143C5.71436 14.5777 6.16588 13.4876 6.96961 12.6839C7.77334 11.8801 8.86343 11.4286 10.0001 11.4286V11.4286ZM5.71436 7.14289H8.5715V9.28575H5.71436V7.14289ZM11.4286 2.85718H14.2858V5.00003H11.4286V2.85718ZM11.4286 7.14289H14.2858V9.28575H11.4286V7.14289Z",
    fill: "#727D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school_icon.68843936330a460037b1534c3e72aac5.svg";
export { ForwardRef as ReactComponent };